import moment from 'moment'
import { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../app/hook'
import { LeaderBoardLayout } from '../../components'
import { appCallbackHandler } from '../../util/AppCallbackHandler'
import { ProfileHeader, ProfileTabs } from './components'
import {
    changeMyProfileName,
    fetchMyProfile,
    fetchPerformance,
} from './myProfileSlice'

export const MyProfile: FC<unknown> = () => {
    const [searchParams] = useSearchParams()

    const { user, performance, error } = useAppSelector(
        (state) => state.profile
    )
    const dispatch = useAppDispatch()

    const noHeader = searchParams.get('noheader') === 'true'

    useEffect(() => {
        appCallbackHandler('setToolbarHeaderUI', 'My Profile')
        console.log('noHeader', noHeader)
    }, [])

    useEffect(() => {
        if (!user && error) {
            appCallbackHandler('tokenExpired')
        }
    }, [user, error])

    useEffect(() => {
        dispatch(fetchMyProfile(searchParams.get('search')))
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
        dispatch(
            fetchPerformance({
                date: yesterday,
                mockAccId: searchParams.get('search'),
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onChangeProfileName = async (name: string) => {
        return await dispatch(
            changeMyProfileName({
                displayName: name,
                appUserId: window.localStorage.getItem('MOCK_ACC_ID'),
            })
        )
    }

    return (
        <LeaderBoardLayout>
            {user && !noHeader ? (
                <ProfileHeader
                    userData={user}
                    onChangeProfileName={onChangeProfileName}
                    editable={
                        window.localStorage.getItem('MOCK_ACC_ID') &&
                        window.localStorage.getItem('MOCK_ACC_ID') ===
                            user?.additional_user_info?.accountId?.toString()
                            ? true
                            : false
                    }
                />
            ) : null}
            <ProfileTabs performance={performance} />
        </LeaderBoardLayout>
    )
}
